module.exports = __webpack_public_path__ + "img/re.be825203.svg";